import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
  function LabReportOp(props) {
      const {id} = useParams();
      const [labData,setlabData] = useState([]);
      const [labtestData,setLabTestData] = useState([]);
      const [labbillData, setLabBillData] = useState([]);
      const [lres, setLres] = useState();
      const [labv, setLabv] = useState({});

    useEffect(() => {
      const fetchData = async () => {
      try {
        const response1 = await axios.get(baseUrl+'lab-report-op/'+id+'/');
        setLabTestData(response1.data);
        setLres(response1.data[0].results.split(','));
        setLabv(response1.data[0].abnormal_status.split(','));
        const ltestid = (response1.data[0].ltest_id);
        const appt_id = (response1.data[0].appt_id);

        const response2 = await axios.get(baseUrl+'lab-test-view/'+ltestid+'/');
        setLabBillData(response2.data);

        const response3 = await axios.get(baseUrl+'lab-pay/'+appt_id)
        setlabData(response3.data);

      } catch (error) {
        console.log(error);
      }
    };
      fetchData();
    }, []);

     const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };


      return (
        <section>
          <div id="invoice-print">
              {labData.map((row, index) =>
              <div>
                <table border="2"  className="text-justify mt-4" width="100%" >
                  <tr >
                   <th className="mx-0 ps-5" rowSpan="10">
                        Name : {row.pat.patient}
                           <br></br>
                        Consultant : Dr.{row.cons.consultant}
                           <br></br>
                        Sample Date : {labData[0].add_date}
                   </th>
                   </tr>
                   <tr >
                   <th>
                        Age/Gender : {row.pat.age}/{row.pat.gender}
                           <br></br>
                        PID : {row.pat.pat_id}<br></br>
                        Report Date : {labtestData[0].sample_date}
                   </th>
                   </tr>
                </table>
              </div>
              )}
              <div>
                <table className="table table-bordered mt-4">
                  <thead>
                    <tr style={{borderColor: "#F2F2F2"}}>
                    <th style={{width: "2px", display: 'none'}} align="left" className="no-print">Checkbox</th>
                       <th align="left">Test</th>
                       <th align="left">Results</th>

                       <th align="left">Units</th>
                       <th align="left">Ranges</th>

                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th colSpan="4" >
                      <h3 style={{color: "black"}}>{labbillData.length > 0 && labbillData[0].cat.category}</h3>
                    </th>
                  </tr>
                  {labbillData.map((lab, billIndex) => (
                    <tr key={billIndex}>
                      <td style={{width: "3px", display: 'none'}}>
                        <input type="checkbox" name={`checkbox-${billIndex}`} />
                      </td>
                      <td >{lab.test}</td>
                      {labtestData.map((test, testIndex) => {
                        const results = test.results.split(',').map(res => res.trim());

                        return (
                          <React.Fragment key={testIndex}>
                          <td >
                          {results[billIndex]}
                          </td>
                          </React.Fragment>
                        );
                      })}
                      <td >{lab.units}</td>
                      <td >{lab.ranges}</td>
                    </tr>
                  ))}
                </tbody>
                </table>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
              onClick={handlePrint}
              >
               Print
              </button>

            </div>
        </section>
      );

  }
export default LabReportOp;

